import { useState, useEffect, Suspense, lazy } from "react";
import "@tennr/style/index.css";
import { HomePage } from "@tennr/frontend/pages/HomePage";
import { Navigation } from "@tennr/frontend/components/Navigation";
import "./SPA.css";
import { WrapperSSR } from "@tennr/frontend/components/SSR";
import { CSSBackground } from "@tennr/frontend/components/WebGLBackground/CSSBackground";
import type { ColorStop } from "@tennr/frontend/components/WebGLBackground";

// lazy load the WebGL background component
const WebGLBackground = lazy(() =>
  import("@tennr/frontend/components/WebGLBackground").then((module) => ({
    default: module.WebGLBackground,
  }))
);

// global Loader Component
const GlobalLoader = () => {
  return null;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // function to handle when DOM is fully loaded
    const handleDOMLoaded = () => {
      // small delay to ensure smooth transition
      setTimeout(() => {
        setLoading(false);
      }, 300);
    };

    if (document.readyState === "complete") {
      handleDOMLoaded();
    } else {
      window.addEventListener("load", handleDOMLoaded);
      return () => {
        window.removeEventListener("load", handleDOMLoaded);
      };
    }
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#9b4e45", // Match initial background color
        zIndex: 9999,
        opacity: loading ? 1 : 0,
        visibility: loading ? "visible" : "hidden",
        transition: "opacity 1.2s ease-in, visibility 1.2s ease-in",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        pointerEvents: loading ? "none" : "none",
      }}
    ></div>
  );
};

export const SPA = () => {
  // define LenisRef type if not already imported

  const colorStops: ColorStop[] = [
    // starting with the first reddish color
    { color: [0.607, 0.306, 0.27], progress: 0.025 }, // #9B4E45
    { color: [0.607, 0.306, 0.27], progress: 0.05 }, // #9B4E45 (holding)
    { color: [0.607, 0.306, 0.27], progress: 0.096 }, // #9B4E45 (holding)

    // transition to lighter beige
    { color: [0.925, 0.843, 0.729], progress: 0.159 }, // Interpolated
    { color: [0.933, 0.875, 0.82], progress: 0.254 }, // #EEDFD1
    { color: [0.933, 0.875, 0.82], progress: 0.315 }, // #EEDFD1 (holding)
    { color: [0.933, 0.875, 0.82], progress: 0.795 }, // #EEDFD1 (holding)
    { color: [0.447, 0.333, 0.302], progress: 0.82 }, // #72554D
    { color: [0.447, 0.333, 0.302], progress: 1.0 }, // #72554D
  ];

  return (
    <div className="app">
      <GlobalLoader />
      <Navigation />
      {/* SSR-safe WebGL background with CSS fallback */}
      <WrapperSSR className="webgl-background">
        <div className="webgl-event-source" />
        <Suspense fallback={<CSSBackground colorStops={colorStops} />}>
          <WebGLBackground colorStops={colorStops} />
        </Suspense>
      </WrapperSSR>
      <HomePage />
    </div>
  );
};
